/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CapturePatientMarketingConsentRequest,
  CartModel,
  ChangePhoneNumberForPlatformUserRequest,
  DisplayChangePhoneNumberForPlatformUserResponse,
  DisplayPagedPatientTextMessagesResponse,
  DisplayPatientTextMessage,
  ExternalTransactionDetails,
  GetMessagesParams,
  GetOrderHistoryParams,
  GetUserRewardHistoryParams,
  GetUserRewardHistoryResultPagedResults,
  GetVisitHistoryResultPagedResults,
  OrderHistoryLineItemModelPagedResults,
  SavePreferencesRequest,
  SetAdvertisingTrackingOptOutRequest,
  UpdateUserRequest,
  UploadImageBody,
  UploadImageCommandResult,
  UserGetVisitHistoryCheckInsParams,
  UserGetVisitHistoryVisitsParams,
  UserModel1,
  UserPreferences
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Uploads an image to AWS or local storage and returns a url.
 */
export const uploadImage = (
    uploadImageBody: UploadImageBody,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(uploadImageBody.file !== undefined) {
 formData.append(`file`, uploadImageBody.file);
 }

      return customAxios<UploadImageCommandResult>(
      {url: `/api/v1/uploads`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getUploadImageMutationKey = () => ['uploadImage'] as const;

export const getUploadImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,UploadImageMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,UploadImageMutationVariables, TContext> => {

const mutationKey = getUploadImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadImage>>, UploadImageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadImage>>>
    export type UploadImageMutationBody = UploadImageBody
    export type UploadImageMutationError = ErrorType<unknown>
    export type UploadImageMutationVariables = {data: UploadImageBody}

    /**
 * @summary Uploads an image to AWS or local storage and returns a url.
 */
export const useUploadImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,UploadImageMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadImage>>,
        TError,
        UploadImageMutationVariables,
        TContext
      > => {
      return useMutation(getUploadImageMutationOptions(options), queryClient);
    }
    /**
 * @summary Gets the current user details.
 */
export const getUserInfo = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UserModel1>(
      {url: `/api/v1/user`, method: 'GET', signal
    },
      options);
    }




export const getGetUserInfoQueryKey = () => {
    return [
    `/api/v1/user`
    ] as const;
    }


export const getGetUserInfoQueryOptions = <TData = Awaited<ReturnType<typeof getUserInfo>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInfo>>> = ({ signal }) => getUserInfo(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInfo>>>
export type GetUserInfoQueryError = ErrorType<void>


export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInfo>>,
          TError,
          Awaited<ReturnType<typeof getUserInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInfo>>,
          TError,
          Awaited<ReturnType<typeof getUserInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the current user details.
 */

export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Delete the current user's account. This will cancel active memberships
and either nullify PII or create an empty user depending on platform associations.
 */
export const deleteAccount = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/user`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAccountMutationKey = () => ['deleteAccount'] as const;

export const getDeleteAccountMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext> => {

const mutationKey = getDeleteAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, void> = () => {


          return  deleteAccount(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>

    export type DeleteAccountMutationError = ErrorType<void>


    /**
 * @summary Delete the current user's account. This will cancel active memberships
and either nullify PII or create an empty user depending on platform associations.
 */
export const useDeleteAccount = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteAccountMutationOptions(options), queryClient);
    }
    /**
 * @summary Update the verified User's information
 */
export const updateUser = (
    updateUserRequest: UpdateUserRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UserModel1>(
      {url: `/api/v1/user/update`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequest, signal
    },
      options);
    }




export const getUpdateUserMutationKey = () => ['updateUser'] as const;

export const getUpdateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext> => {

const mutationKey = getUpdateUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, UpdateUserMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UpdateUserRequest
    export type UpdateUserMutationError = ErrorType<unknown>
    export type UpdateUserMutationVariables = {data: UpdateUserRequest}

    /**
 * @summary Update the verified User's information
 */
export const useUpdateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        UpdateUserMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options), queryClient);
    }
    /**
 * @summary Records the marketing disclosure accepted by the authenticated patient after phone verification.
 */
export const captureMarketingConsent = (
    capturePatientMarketingConsentRequest: CapturePatientMarketingConsentRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/user/marketing-consent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: capturePatientMarketingConsentRequest, signal
    },
      options);
    }




export const getCaptureMarketingConsentMutationKey = () => ['captureMarketingConsent'] as const;

export const getCaptureMarketingConsentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof captureMarketingConsent>>, TError,CaptureMarketingConsentMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof captureMarketingConsent>>, TError,CaptureMarketingConsentMutationVariables, TContext> => {

const mutationKey = getCaptureMarketingConsentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureMarketingConsent>>, CaptureMarketingConsentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  captureMarketingConsent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CaptureMarketingConsentMutationResult = NonNullable<Awaited<ReturnType<typeof captureMarketingConsent>>>
    export type CaptureMarketingConsentMutationBody = CapturePatientMarketingConsentRequest
    export type CaptureMarketingConsentMutationError = ErrorType<unknown>
    export type CaptureMarketingConsentMutationVariables = {data: CapturePatientMarketingConsentRequest}

    /**
 * @summary Records the marketing disclosure accepted by the authenticated patient after phone verification.
 */
export const useCaptureMarketingConsent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof captureMarketingConsent>>, TError,CaptureMarketingConsentMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof captureMarketingConsent>>,
        TError,
        CaptureMarketingConsentMutationVariables,
        TContext
      > => {
      return useMutation(getCaptureMarketingConsentMutationOptions(options), queryClient);
    }
    /**
 * @summary Records the authenticated patient's choice to opt out of (or back in to) advertising trackers on this practice's app.
 */
export const setAdvertisingTrackingOptOut = (
    setAdvertisingTrackingOptOutRequest: SetAdvertisingTrackingOptOutRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/user/advertising-opt-out`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAdvertisingTrackingOptOutRequest, signal
    },
      options);
    }




export const getSetAdvertisingTrackingOptOutMutationKey = () => ['setAdvertisingTrackingOptOut'] as const;

export const getSetAdvertisingTrackingOptOutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdvertisingTrackingOptOut>>, TError,SetAdvertisingTrackingOptOutMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdvertisingTrackingOptOut>>, TError,SetAdvertisingTrackingOptOutMutationVariables, TContext> => {

const mutationKey = getSetAdvertisingTrackingOptOutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdvertisingTrackingOptOut>>, SetAdvertisingTrackingOptOutMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setAdvertisingTrackingOptOut(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdvertisingTrackingOptOutMutationResult = NonNullable<Awaited<ReturnType<typeof setAdvertisingTrackingOptOut>>>
    export type SetAdvertisingTrackingOptOutMutationBody = SetAdvertisingTrackingOptOutRequest
    export type SetAdvertisingTrackingOptOutMutationError = ErrorType<unknown>
    export type SetAdvertisingTrackingOptOutMutationVariables = {data: SetAdvertisingTrackingOptOutRequest}

    /**
 * @summary Records the authenticated patient's choice to opt out of (or back in to) advertising trackers on this practice's app.
 */
export const useSetAdvertisingTrackingOptOut = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdvertisingTrackingOptOut>>, TError,SetAdvertisingTrackingOptOutMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAdvertisingTrackingOptOut>>,
        TError,
        SetAdvertisingTrackingOptOutMutationVariables,
        TContext
      > => {
      return useMutation(getSetAdvertisingTrackingOptOutMutationOptions(options), queryClient);
    }
    /**
 * @summary Get a list of the user's previously redeemed rewards.
 */
export const getUserRewardHistory = (
    params?: GetUserRewardHistoryParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetUserRewardHistoryResultPagedResults>(
      {url: `/api/v1/user/reward-history`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUserRewardHistoryQueryKey = (params?: GetUserRewardHistoryParams,) => {
    return [
    `/api/v1/user/reward-history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserRewardHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getUserRewardHistory>>, TError = ErrorType<unknown>>(params?: GetUserRewardHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserRewardHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRewardHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserRewardHistory>>> = ({ signal }) => getUserRewardHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserRewardHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserRewardHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getUserRewardHistory>>>
export type GetUserRewardHistoryQueryError = ErrorType<unknown>


export function useGetUserRewardHistory<TData = Awaited<ReturnType<typeof getUserRewardHistory>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserRewardHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserRewardHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserRewardHistory>>,
          TError,
          Awaited<ReturnType<typeof getUserRewardHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserRewardHistory<TData = Awaited<ReturnType<typeof getUserRewardHistory>>, TError = ErrorType<unknown>>(
 params?: GetUserRewardHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserRewardHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserRewardHistory>>,
          TError,
          Awaited<ReturnType<typeof getUserRewardHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserRewardHistory<TData = Awaited<ReturnType<typeof getUserRewardHistory>>, TError = ErrorType<unknown>>(
 params?: GetUserRewardHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserRewardHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a list of the user's previously redeemed rewards.
 */

export function useGetUserRewardHistory<TData = Awaited<ReturnType<typeof getUserRewardHistory>>, TError = ErrorType<unknown>>(
 params?: GetUserRewardHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserRewardHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserRewardHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get a list of the User's previous visits, i.e. their previous visits to one or more platforms.
 */
export const userGetVisitHistoryCheckIns = (
    params?: UserGetVisitHistoryCheckInsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetVisitHistoryResultPagedResults>(
      {url: `/api/v1/user/check-ins`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserGetVisitHistoryCheckInsQueryKey = (params?: UserGetVisitHistoryCheckInsParams,) => {
    return [
    `/api/v1/user/check-ins`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserGetVisitHistoryCheckInsQueryOptions = <TData = Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError = ErrorType<unknown>>(params?: UserGetVisitHistoryCheckInsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetVisitHistoryCheckInsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>> = ({ signal }) => userGetVisitHistoryCheckIns(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserGetVisitHistoryCheckInsQueryResult = NonNullable<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>>
export type UserGetVisitHistoryCheckInsQueryError = ErrorType<unknown>


export function useUserGetVisitHistoryCheckIns<TData = Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetVisitHistoryCheckInsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>,
          TError,
          Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserGetVisitHistoryCheckIns<TData = Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError = ErrorType<unknown>>(
 params?: UserGetVisitHistoryCheckInsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>,
          TError,
          Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserGetVisitHistoryCheckIns<TData = Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError = ErrorType<unknown>>(
 params?: UserGetVisitHistoryCheckInsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a list of the User's previous visits, i.e. their previous visits to one or more platforms.
 */

export function useUserGetVisitHistoryCheckIns<TData = Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError = ErrorType<unknown>>(
 params?: UserGetVisitHistoryCheckInsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserGetVisitHistoryCheckInsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get a list of the User's previous visits, i.e. their previous visits to one or more platforms.
 */
export const userGetVisitHistoryVisits = (
    params?: UserGetVisitHistoryVisitsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetVisitHistoryResultPagedResults>(
      {url: `/api/v1/user/visits`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUserGetVisitHistoryVisitsQueryKey = (params?: UserGetVisitHistoryVisitsParams,) => {
    return [
    `/api/v1/user/visits`, ...(params ? [params] : [])
    ] as const;
    }


export const getUserGetVisitHistoryVisitsQueryOptions = <TData = Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError = ErrorType<unknown>>(params?: UserGetVisitHistoryVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetVisitHistoryVisitsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>> = ({ signal }) => userGetVisitHistoryVisits(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserGetVisitHistoryVisitsQueryResult = NonNullable<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>>
export type UserGetVisitHistoryVisitsQueryError = ErrorType<unknown>


export function useUserGetVisitHistoryVisits<TData = Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError = ErrorType<unknown>>(
 params: undefined |  UserGetVisitHistoryVisitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetVisitHistoryVisits>>,
          TError,
          Awaited<ReturnType<typeof userGetVisitHistoryVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserGetVisitHistoryVisits<TData = Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError = ErrorType<unknown>>(
 params?: UserGetVisitHistoryVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userGetVisitHistoryVisits>>,
          TError,
          Awaited<ReturnType<typeof userGetVisitHistoryVisits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserGetVisitHistoryVisits<TData = Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError = ErrorType<unknown>>(
 params?: UserGetVisitHistoryVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a list of the User's previous visits, i.e. their previous visits to one or more platforms.
 */

export function useUserGetVisitHistoryVisits<TData = Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError = ErrorType<unknown>>(
 params?: UserGetVisitHistoryVisitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserGetVisitHistoryVisitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get a page of the text messages the current practice sent the user, newest first.
 */
export const getMessages = (
    params?: GetMessagesParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayPagedPatientTextMessagesResponse>(
      {url: `/api/v1/user/messages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetMessagesQueryKey = (params?: GetMessagesParams,) => {
    return [
    `/api/v1/user/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(params?: GetMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessages>>> = ({ signal }) => getMessages(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getMessages>>>
export type GetMessagesQueryError = ErrorType<unknown>


export function useGetMessages<TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessages>>,
          TError,
          Awaited<ReturnType<typeof getMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessages<TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(
 params?: GetMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessages>>,
          TError,
          Awaited<ReturnType<typeof getMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessages<TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(
 params?: GetMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a page of the text messages the current practice sent the user, newest first.
 */

export function useGetMessages<TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(
 params?: GetMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get one text message the current practice sent the user.
 */
export const getMessage = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayPatientTextMessage>(
      {url: `/api/v1/user/messages/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetMessageQueryKey = (id: string,) => {
    return [
    `/api/v1/user/messages/${id}`
    ] as const;
    }


export const getGetMessageQueryOptions = <TData = Awaited<ReturnType<typeof getMessage>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessage>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessage>>> = ({ signal }) => getMessage(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessageQueryResult = NonNullable<Awaited<ReturnType<typeof getMessage>>>
export type GetMessageQueryError = ErrorType<void>


export function useGetMessage<TData = Awaited<ReturnType<typeof getMessage>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessage>>,
          TError,
          Awaited<ReturnType<typeof getMessage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessage<TData = Awaited<ReturnType<typeof getMessage>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessage>>,
          TError,
          Awaited<ReturnType<typeof getMessage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessage<TData = Awaited<ReturnType<typeof getMessage>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessage>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one text message the current practice sent the user.
 */

export function useGetMessage<TData = Awaited<ReturnType<typeof getMessage>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessage>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get a paginated list of the User's Order History
 */
export const getOrderHistory = (
    params?: GetOrderHistoryParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<OrderHistoryLineItemModelPagedResults>(
      {url: `/api/v1/user/orders`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetOrderHistoryQueryKey = (params?: GetOrderHistoryParams,) => {
    return [
    `/api/v1/user/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrderHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getOrderHistory>>, TError = ErrorType<void>>(params?: GetOrderHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderHistory>>> = ({ signal }) => getOrderHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderHistory>>>
export type GetOrderHistoryQueryError = ErrorType<void>


export function useGetOrderHistory<TData = Awaited<ReturnType<typeof getOrderHistory>>, TError = ErrorType<void>>(
 params: undefined |  GetOrderHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderHistory>>,
          TError,
          Awaited<ReturnType<typeof getOrderHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderHistory<TData = Awaited<ReturnType<typeof getOrderHistory>>, TError = ErrorType<void>>(
 params?: GetOrderHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderHistory>>,
          TError,
          Awaited<ReturnType<typeof getOrderHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderHistory<TData = Awaited<ReturnType<typeof getOrderHistory>>, TError = ErrorType<void>>(
 params?: GetOrderHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a paginated list of the User's Order History
 */

export function useGetOrderHistory<TData = Awaited<ReturnType<typeof getOrderHistory>>, TError = ErrorType<void>>(
 params?: GetOrderHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get details on a specific User's Order
 */
export const getOrderHistoryDetails = (
    shopDisplayOrderId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CartModel>(
      {url: `/api/v1/user/orders/${shopDisplayOrderId}`, method: 'GET', signal
    },
      options);
    }




export const getGetOrderHistoryDetailsQueryKey = (shopDisplayOrderId: string,) => {
    return [
    `/api/v1/user/orders/${shopDisplayOrderId}`
    ] as const;
    }


export const getGetOrderHistoryDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError = ErrorType<void>>(shopDisplayOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderHistoryDetailsQueryKey(shopDisplayOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderHistoryDetails>>> = ({ signal }) => getOrderHistoryDetails(shopDisplayOrderId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: shopDisplayOrderId !== null && shopDisplayOrderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderHistoryDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderHistoryDetails>>>
export type GetOrderHistoryDetailsQueryError = ErrorType<void>


export function useGetOrderHistoryDetails<TData = Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError = ErrorType<void>>(
 shopDisplayOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderHistoryDetails>>,
          TError,
          Awaited<ReturnType<typeof getOrderHistoryDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderHistoryDetails<TData = Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError = ErrorType<void>>(
 shopDisplayOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderHistoryDetails>>,
          TError,
          Awaited<ReturnType<typeof getOrderHistoryDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderHistoryDetails<TData = Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError = ErrorType<void>>(
 shopDisplayOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get details on a specific User's Order
 */

export function useGetOrderHistoryDetails<TData = Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError = ErrorType<void>>(
 shopDisplayOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderHistoryDetailsQueryOptions(shopDisplayOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the current user's external transaction history, enriched with the adjusting admin's name where applicable.
 */
export const getExternalTransactions = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalTransactionDetails[]>(
      {url: `/api/v1/user/external-transactions`, method: 'GET', signal
    },
      options);
    }




export const getGetExternalTransactionsQueryKey = () => {
    return [
    `/api/v1/user/external-transactions`
    ] as const;
    }


export const getGetExternalTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getExternalTransactions>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalTransactions>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalTransactionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalTransactions>>> = ({ signal }) => getExternalTransactions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExternalTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExternalTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalTransactions>>>
export type GetExternalTransactionsQueryError = ErrorType<unknown>


export function useGetExternalTransactions<TData = Awaited<ReturnType<typeof getExternalTransactions>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalTransactions>>,
          TError,
          Awaited<ReturnType<typeof getExternalTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalTransactions<TData = Awaited<ReturnType<typeof getExternalTransactions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExternalTransactions>>,
          TError,
          Awaited<ReturnType<typeof getExternalTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExternalTransactions<TData = Awaited<ReturnType<typeof getExternalTransactions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalTransactions>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the current user's external transaction history, enriched with the adjusting admin's name where applicable.
 */

export function useGetExternalTransactions<TData = Awaited<ReturnType<typeof getExternalTransactions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExternalTransactions>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExternalTransactionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Check if the user can check-in
 */
export const checkIfUserCanCheckIn = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<boolean>(
      {url: `/api/v1/user/check-in`, method: 'GET', signal
    },
      options);
    }




export const getCheckIfUserCanCheckInQueryKey = () => {
    return [
    `/api/v1/user/check-in`
    ] as const;
    }


export const getCheckIfUserCanCheckInQueryOptions = <TData = Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckIfUserCanCheckInQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>> = ({ signal }) => checkIfUserCanCheckIn(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckIfUserCanCheckInQueryResult = NonNullable<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>>
export type CheckIfUserCanCheckInQueryError = ErrorType<unknown>


export function useCheckIfUserCanCheckIn<TData = Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkIfUserCanCheckIn>>,
          TError,
          Awaited<ReturnType<typeof checkIfUserCanCheckIn>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckIfUserCanCheckIn<TData = Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkIfUserCanCheckIn>>,
          TError,
          Awaited<ReturnType<typeof checkIfUserCanCheckIn>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckIfUserCanCheckIn<TData = Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check if the user can check-in
 */

export function useCheckIfUserCanCheckIn<TData = Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckIfUserCanCheckInQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get user preferences (journey experience, skin tone, concerns, etc.)
 */
export const getPreferences = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UserPreferences>(
      {url: `/api/v1/user/preferences`, method: 'GET', signal
    },
      options);
    }




export const getGetPreferencesQueryKey = () => {
    return [
    `/api/v1/user/preferences`
    ] as const;
    }


export const getGetPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getPreferences>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreferences>>> = ({ signal }) => getPreferences(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getPreferences>>>
export type GetPreferencesQueryError = ErrorType<void>


export function useGetPreferences<TData = Awaited<ReturnType<typeof getPreferences>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreferences>>,
          TError,
          Awaited<ReturnType<typeof getPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreferences<TData = Awaited<ReturnType<typeof getPreferences>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPreferences>>,
          TError,
          Awaited<ReturnType<typeof getPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreferences<TData = Awaited<ReturnType<typeof getPreferences>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user preferences (journey experience, skin tone, concerns, etc.)
 */

export function useGetPreferences<TData = Awaited<ReturnType<typeof getPreferences>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Save user preferences (journey experience, skin tone, concerns, etc.)
 */
export const savePreferences = (
    savePreferencesRequest: SavePreferencesRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/user/preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: savePreferencesRequest, signal
    },
      options);
    }




export const getSavePreferencesMutationKey = () => ['savePreferences'] as const;

export const getSavePreferencesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePreferences>>, TError,SavePreferencesMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof savePreferences>>, TError,SavePreferencesMutationVariables, TContext> => {

const mutationKey = getSavePreferencesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof savePreferences>>, SavePreferencesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  savePreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SavePreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof savePreferences>>>
    export type SavePreferencesMutationBody = SavePreferencesRequest
    export type SavePreferencesMutationError = ErrorType<void>
    export type SavePreferencesMutationVariables = {data: SavePreferencesRequest}

    /**
 * @summary Save user preferences (journey experience, skin tone, concerns, etc.)
 */
export const useSavePreferences = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePreferences>>, TError,SavePreferencesMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof savePreferences>>,
        TError,
        SavePreferencesMutationVariables,
        TContext
      > => {
      return useMutation(getSavePreferencesMutationOptions(options), queryClient);
    }
    /**
 * @summary Change the phone number of the current user. If another user already uses the number, the current
platform user is linked to that user instead.
 */
export const changePhoneNumber = (
    changePhoneNumberForPlatformUserRequest: ChangePhoneNumberForPlatformUserRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayChangePhoneNumberForPlatformUserResponse>(
      {url: `/api/v1/user/phone-number`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changePhoneNumberForPlatformUserRequest, signal
    },
      options);
    }




export const getChangePhoneNumberMutationKey = () => ['changePhoneNumber'] as const;

export const getChangePhoneNumberMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePhoneNumber>>, TError,ChangePhoneNumberMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof changePhoneNumber>>, TError,ChangePhoneNumberMutationVariables, TContext> => {

const mutationKey = getChangePhoneNumberMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePhoneNumber>>, ChangePhoneNumberMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  changePhoneNumber(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof changePhoneNumber>>>
    export type ChangePhoneNumberMutationBody = ChangePhoneNumberForPlatformUserRequest
    export type ChangePhoneNumberMutationError = ErrorType<void>
    export type ChangePhoneNumberMutationVariables = {data: ChangePhoneNumberForPlatformUserRequest}

    /**
 * @summary Change the phone number of the current user. If another user already uses the number, the current
platform user is linked to that user instead.
 */
export const useChangePhoneNumber = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePhoneNumber>>, TError,ChangePhoneNumberMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePhoneNumber>>,
        TError,
        ChangePhoneNumberMutationVariables,
        TContext
      > => {
      return useMutation(getChangePhoneNumberMutationOptions(options), queryClient);
    }
